import { IS_IBG_MANAGER } from "@/consts";
import { computed } from "vue";

export function useDashboardPermissions() {
  const view = computed(() => {
    return IS_IBG_MANAGER;
  });

  return { view };
}
